<template>
  <div>
    <header-component></header-component>

    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform:capitalize;">Expense Types List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button size="sm" type="primary" @click="createExpenseType">Add New</base-button>
          </div>
        </div>
        <el-table
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
          :data="expenseTypeList"
        >
          <el-table-column label="Expense Type Name" min-width="170px" sortable>
            <template slot-scope="scope">{{ scope.row.label}}</template>
          </el-table-column>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown slot="dropdown" @command="command => handleAction(scope.row, command)">
                 <el-button type="primary" size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog title="Add Expense Type" :visible.sync="addExpenseType">
        <add-expense-type @close="addExpenseType = false"></add-expense-type>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import AddExpenseType from "./AddExpenseType";
import headerComponent from "../Components/HeaderComponent";

export default {
  data: () => {
    return {
      addExpenseType: false
    };
  },

  computed: {
    ...mapGetters({
      expenseTypeList: "expense/getExpenseTypeList",
      expenseType: "expense/getExpenseType"
    })
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    "add-expense-type": AddExpenseType,
    [Dialog.name]: Dialog,
    [Button.name] : Button,
    "header-component": headerComponent
  },

  mounted() {
    this.getExpenseTypes();
  },

  methods: {
    ...mapActions({
      getExpenseTypes: "expense/getExpenseTypes",
      fetchExpenseType: "expense/fetchExpenseType"
    }),
    ...mapMutations({
      setExpenseType: "expense/setExpenseType",
      resetExpenseType: "expense/resetExpenseType"
    }),
    handleAction(expenseType, command) {
      if (command === "edit") {
        this.fetchExpenseType(expenseType.expenseTypeId).then(res => {
          this.addExpenseType = true;
          this.setExpenseType(res);
        });
      }
    },
    createExpenseType() {
      this.resetExpenseType();
      this.addExpenseType = true;
    }
  }
};
</script>